"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadJobLogBase = exports.useSearchJobLogsBase = exports.useJobRunBase = exports.useDeleteJobBase = exports.useUpdateJobBase = exports.useCreateJobBase = exports.useLoadExternalJobBase = exports.useLoadJobBase = exports.useSearchJobsBase = void 0;
var react_1 = require("react");
var loading_1 = require("remota-client/hook/loading");
var multi_1 = require("remota-client/hook/multi");
var useSearchJobsBase = function (module, state, query) {
    return (0, multi_1.useSearch)(module, state, "/api/voucher/jobs", query);
};
exports.useSearchJobsBase = useSearchJobsBase;
var useLoadJobBase = function (module, state, id) {
    return (0, multi_1.useLoad)(module, state, "/api/voucher/jobs/".concat(id), id);
};
exports.useLoadJobBase = useLoadJobBase;
var useLoadExternalJobBase = function (module, state, id) {
    return (0, multi_1.useLoad)(module, state, "/api/external/voucher/jobs/".concat(id), id, { notifyOnFailure: false });
};
exports.useLoadExternalJobBase = useLoadExternalJobBase;
var useCreateJobBase = function (module, state) {
    return (0, multi_1.useCreate)(module, state, "/api/voucher/jobs");
};
exports.useCreateJobBase = useCreateJobBase;
var useUpdateJobBase = function (module, state, id) {
    return (0, multi_1.useUpdate)(module, state, "/api/voucher/jobs/".concat(id));
};
exports.useUpdateJobBase = useUpdateJobBase;
var useDeleteJobBase = function (module, state, id) {
    return (0, multi_1.useDelete)(module, state, "/api/voucher/jobs/".concat(id), id);
};
exports.useDeleteJobBase = useDeleteJobBase;
var useJobRunBase = function (loadingState, isExternal) {
    var _a;
    var _b = __read((0, react_1.useState)({ job: null, trigger: undefined, t: undefined }), 2), state = _b[0], setState = _b[1];
    var body = (0, react_1.useMemo)(function () { return ({ trigger: state.trigger, external: isExternal ? "true" : "false", t: state.t }); }, [
        state.trigger,
        isExternal,
        state.t,
    ]);
    var status = (0, loading_1.useHttpPost)(loadingState, "/batch/".concat((_a = state.job) === null || _a === void 0 ? void 0 : _a.id), body, state.job !== null, undefined, undefined);
    var run = (0, react_1.useCallback)(function (job, trigger, t) {
        setState({ job: job, trigger: trigger, t: t });
    }, [setState]);
    return (0, react_1.useMemo)(function () { return [run, status]; }, [run, status]);
};
exports.useJobRunBase = useJobRunBase;
var useSearchJobLogsBase = function (module, state, query) {
    return (0, multi_1.useSearch)(module, state, "/api/voucher/job_logs", query);
};
exports.useSearchJobLogsBase = useSearchJobLogsBase;
var useLoadJobLogBase = function (module, state, id) {
    return (0, multi_1.useLoad)(module, state, "/api/voucher/job_logs/".concat(id), id);
};
exports.useLoadJobLogBase = useLoadJobLogBase;
